<template>
    <v-avatar :size="size" :color="color" :class="avatarclass" v-bind="menuAttrs" v-on="menuOn">
        <v-img
            v-if="src"
            :src="`${src}?${initialTimestamp}`"
            :alt="alt"
        />
        <v-icon v-else dark>
            mdi-account
        </v-icon>
    </v-avatar>
</template>

<script>
    export default {
        props: {
            color: {
                type: String,
                default: 'white'
            },
            src: {
                type: String,
                default: null
            },
            alt: {
                type: String,
                default: ''
            },
            size: {
                type: Number,
                default: 40
            },
            avatarclass: {
                type: String,
                default: ''
            },
            menuAttrs:{},
            menuOn:{}
        },

        data() {
            return {
                initialTimestamp:new Date().getTime()
            }
        },
        
    }
</script>

<style lang="scss" scoped>

</style>